import { render, staticRenderFns } from "./BriqDrawer.vue?vue&type=template&id=558e4dfc&scoped=true&lang=pug&"
import script from "./BriqDrawer.vue?vue&type=script&lang=js&"
export * from "./BriqDrawer.vue?vue&type=script&lang=js&"
import style0 from "./BriqDrawer.vue?vue&type=style&index=0&id=558e4dfc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558e4dfc",
  null
  
)

export default component.exports